// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 508) return "static/chunks/508-01f3331b255568ab.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"118":"3a7b2ccb7ccbbae5","867":"9396fdae727147a9","871":"33e01b1d671c0ec9"}[chunkId] + ".js";
};